/*
 * Feste Kaufleiste auf dem Handy (Produktseite). Sie erscheint, sobald der eigentliche Kauf-Knopf nicht im Bild ist, zeigt
 * Name, Preis und "In den Warenkorb" und tippt dabei den echten Knopf an. So gelten Charm Bar, Notiz und alle Prüfungen wie sonst.
 * Zustand (Ausverkauft, Lädt) wird vom echten Knopf übernommen.
 */
(function () {
  var form = document.querySelector('form[data-type="add-to-cart-form"]');
  var mainBtn = form && form.querySelector('button[type="submit"][name="add"]');
  var bar = document.querySelector('[data-fgh-sticky]');
  if (!mainBtn || !bar || !('IntersectionObserver' in window)) return;
  var btn = bar.querySelector('[data-sticky-btn]');
  var priceEl = bar.querySelector('[data-sticky-price]');

  function readPrice() {
    var p = document.querySelector('.product__info-container .price .price-item--last, .product__info-container .price-item--regular');
    return p ? p.textContent.replace(/\s+/g, ' ').replace(/\s*EUR$/, '').trim() : '';
  }
  function sync() {
    var label = mainBtn.querySelector('span');
    var text = (label ? label.textContent : mainBtn.textContent).replace(/\s+/g, ' ').trim();
    btn.textContent = text || 'In den Warenkorb';
    btn.disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
    priceEl.textContent = readPrice();
  }
  sync();
  new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
  var pi = document.querySelector('.product__info-container');
  if (pi) new MutationObserver(function () { priceEl.textContent = readPrice(); }).observe(pi, { childList: true, subtree: true, characterData: true });

  var io = new IntersectionObserver(function (entries) {
    var visible = entries[0].isIntersecting;
    bar.classList.toggle('is-on', !visible);
    document.documentElement.classList.toggle('fgh-sticky-on', !visible);
  }, { threshold: 0 });
  io.observe(mainBtn);

  btn.addEventListener('click', function () { if (!btn.disabled) mainBtn.click(); });
})();
